/*=========================================================================================
  File Name: moduleKVDRState.js
  Description: KVDR module state
  ----------------------------------------------------------------------------------------
  Item Name: KVDR - key value driving role
  Author: Ashwani Bhardwaj
  Author Email: bhardwaj.ashwani92@gmail.com
==========================================================================================*/

export default {
  selectedKVDR: {}
};
